import styled from "styled-components";
import Paper from "components/Layout/Paper";
import { COLORS } from "constants/colorScheme";
const CARD_HEIGHT = 60;

export const Container = styled.div`
  border-radius: 6px;
  padding: 6px 8px 7px 12px;
  background-color: ${COLORS.BACKGROUND};

  display: flex;
  align-items: center;

  margin-right: 12px;
  margin-top: 12px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  min-height: 24px;
  min-width: 24px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;
`;

export const ClearIconContainer = styled.span`
  display: flex;
  margin-left: 8px;

  cursor: pointer;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: center;

  height: ${CARD_HEIGHT}px;
  width: 100%;

  padding: 24px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ControlWrapper = styled.div`
  margin-right: 40px;
`;

export const MenuControlWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-right: 24px;
`;

export const Menu = styled.div`
  display: flex;

  & path,
  & use {
    fill: ${COLORS.BLACK_50};
  }
`;
